<template>
      <div class="flex flex-col justify-between h-full tab-filters">
            <transition-group name="slide-fade" tag="div" class="tab-wrapper grid gap-4">
                  <div class="form" v-for="(filter, index) in filters" :key="filter.name">
                        <div class="flex justify-between">
                              <label for="status">{{ $t(filter.name) }}</label>
                              <div class="options flex space-x-2">
                                    <div v-if="filter.name === Vue.Constants.PATH_FILTER_NAME || filter.name === Vue.Constants.PATH_ENUM_FILTER_NAME" @click="openModalNewPath(null, filter.name === Vue.Constants.PATH_FILTER_NAME ? paths : enums(filter.name), filter.name)"><feather class="p-2 hover:bg-gray-200 rounded cursor-pointer" :type="filter.name === Vue.Constants.PATH_FILTER_NAME ? 'plus' : 'edit-2'" :size='14' stroke='#141935' v-tooltip="filter.name === Vue.Constants.PATH_FILTER_NAME ? $t('add_path') : $t('select_path')"></feather></div>
                                    <div v-if="!isDerived" class="remove-filter" @click="removeFilter(index)"><feather class="p-2 hover:bg-gray-200 rounded cursor-pointer" type="x" :size='14' stroke='#141935' v-tooltip="$t('delete_filter')"></feather></div>
                              </div>
                        </div>
                        <!-- based on filter type show option : -->
                        <template v-if="filter.name === Vue.Constants.PATH_FILTER_NAME || filter.name === Vue.Constants.PATH_ENUM_FILTER_NAME">
                              <p class="text-right text-gray-400 pr-10" v-if="filter.name === Vue.Constants.PATH_FILTER_NAME && (!filter.value || !filter.value.length)">{{ $t('add_path') }} <feather class="" type="corner-right-up" :size='34' stroke='#E5E7EB' stroke-width="1"></feather></p>
                              <ul class="mt-2">
                                    <li v-for="(path,index) in filter.value" :key="path" class="flex justify-between items-center mt-2">
                                          <span>{{ path }}</span>
                                          <feather v-if="filter.name === Vue.Constants.PATH_FILTER_NAME" @click="removePath(filter.value, index)" class="p-2 hover:bg-gray-200 rounded cursor-pointer" type="x" :size='14' stroke='#141935' v-tooltip="$t('delete_path')"></feather>
                                    </li>
                              </ul>
                        </template>

                        <!-- date -->
                        <multiselect v-else-if="filter.type === 'date'" :refresh="refresh" :value="filter.value" @select="filterValue($event, index)" :multiple="false" :options="['true', 'false']" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
                        <!-- integer -->
                        <div v-else-if="filter.type === 'integer'" class="flex justify-between items-center">
                              <input type="number" :value="fromToValue(filter.value,0)" @input="filterValue(parseFloat($event.target.value), index, 0)" :placeholder="$t('from_number')" :max="fromToValue(filter.value,1)">
                              <span class="flex mx-4">
                                    <feather type="arrow-left" size="18px" stroke='#141935' class=""></feather>
                                    <feather type="arrow-right" size="18px" stroke='#141935' class=""></feather>
                              </span>
                              <input type="number" :value="fromToValue(filter.value,1)" @input="filterValue(parseFloat($event.target.value), index, 1)" :placeholder="$t('to_number')" :min="fromToValue(filter.value,0)">
                        </div>
                        <!-- singleInteger -->
                        <div v-else-if="filter.type === 'singleInteger'" class="flex justify-between items-center">
                              <input type="number" :value="fromToValue(filter.value,1)" @input="filterValue(parseFloat($event.target.value), index, 1)" :placeholder="$t('number')" :min="fromToValue(filter.value,0)" :max="fromToValue(filter.value,2)">
                        </div>
                        <!-- string -->
                        <div v-else-if="filter.type === 'string'" class="relative" >
                              <input style="padding-right:3rem;" type="text" :value="filter.value" @input="filterValue($event.target.value, index)" :placeholder="$t('enter_text')">
                              <div
                                    :class="!filter.like ? 'active hover:text-white' : 'hover:text-navy hover:border hover:border-navy'"
                                    @click="toggleExactMatch(filter.like, index)"
                                    class="absolute btn-exact-match cursor-pointer flex w-10 h-full items-center justify-center right-0 rounded text-gray-400 top-0"
                                    v-tooltip="!filter.like ? 'Exact match enabled' : 'Click to enable exact match'">
                                    <svg class="fill-current" width="100%" height="100%" viewBox="0 0 10 10" xml:space="preserve" style="transform: scale(0.6)">
                                          <g transform="matrix(1,0,0,1,0,-0.483331)">
                                                <g transform="matrix(1.35103,0,0,1.00214,-5.0877,0.0628281)">
                                                      <path d="M6.294,3.945C6.561,3.945 6.767,4.037 6.914,4.22C7.06,4.404 7.134,4.647 7.134,4.951L7.134,6.944C7.134,6.996 7.114,7.022 7.076,7.022L6.876,7.022C6.838,7.022 6.818,6.996 6.818,6.944L6.818,6.729C6.818,6.717 6.815,6.709 6.809,6.705C6.803,6.701 6.798,6.705 6.792,6.717C6.712,6.833 6.612,6.92 6.492,6.98C6.372,7.04 6.241,7.07 6.099,7.07C5.892,7.07 5.718,6.998 5.577,6.854C5.436,6.711 5.366,6.491 5.366,6.196C5.366,5.897 5.447,5.66 5.608,5.486C5.769,5.313 5.994,5.226 6.281,5.226L6.796,5.226C6.811,5.226 6.818,5.216 6.818,5.196L6.818,4.975C6.818,4.771 6.776,4.61 6.692,4.493C6.607,4.375 6.476,4.316 6.299,4.316C6.16,4.316 6.046,4.352 5.957,4.424C5.868,4.496 5.812,4.595 5.788,4.723C5.779,4.771 5.757,4.791 5.721,4.783L5.504,4.747C5.465,4.739 5.447,4.717 5.45,4.681C5.48,4.462 5.571,4.284 5.724,4.148C5.876,4.013 6.066,3.945 6.294,3.945ZM6.17,6.705C6.345,6.705 6.496,6.646 6.625,6.528C6.754,6.41 6.818,6.252 6.818,6.052L6.818,5.591C6.818,5.571 6.811,5.561 6.796,5.561L6.33,5.561C6.134,5.561 5.977,5.615 5.859,5.723C5.741,5.831 5.681,5.98 5.681,6.172C5.681,6.348 5.727,6.48 5.819,6.57C5.911,6.66 6.028,6.705 6.17,6.705Z" style="fill-rule:nonzero;"/>
                                                      <path d="M9.514,4.765C9.55,4.929 9.567,5.176 9.567,5.507C9.567,5.835 9.547,6.088 9.505,6.268C9.452,6.515 9.355,6.711 9.214,6.854C9.074,6.998 8.9,7.07 8.692,7.07C8.574,7.07 8.467,7.038 8.37,6.974C8.274,6.91 8.194,6.821 8.128,6.705C8.122,6.697 8.117,6.694 8.111,6.696C8.105,6.698 8.102,6.705 8.102,6.717L8.102,6.944C8.102,6.996 8.083,7.022 8.044,7.022L7.844,7.022C7.806,7.022 7.786,6.996 7.786,6.944L7.786,2.909C7.786,2.857 7.806,2.831 7.844,2.831L8.044,2.831C8.083,2.831 8.102,2.857 8.102,2.909L8.102,4.292C8.102,4.304 8.105,4.312 8.111,4.316C8.117,4.32 8.122,4.316 8.128,4.304C8.194,4.188 8.275,4.099 8.373,4.038C8.47,3.976 8.577,3.945 8.692,3.945C8.903,3.945 9.079,4.018 9.221,4.163C9.363,4.309 9.461,4.51 9.514,4.765ZM9.172,6.232C9.202,6.148 9.222,6.053 9.234,5.947C9.246,5.842 9.252,5.695 9.252,5.507C9.252,5.312 9.244,5.159 9.228,5.049C9.211,4.94 9.185,4.841 9.15,4.753C9.111,4.621 9.049,4.515 8.963,4.436C8.877,4.356 8.775,4.316 8.657,4.316C8.544,4.316 8.447,4.357 8.366,4.439C8.285,4.52 8.226,4.629 8.191,4.765C8.161,4.849 8.14,4.946 8.128,5.055C8.117,5.165 8.111,5.316 8.111,5.507C8.111,5.699 8.117,5.849 8.128,5.956C8.14,6.064 8.159,6.158 8.186,6.238C8.225,6.377 8.284,6.489 8.364,6.573C8.444,6.657 8.543,6.699 8.661,6.699C8.786,6.699 8.893,6.657 8.983,6.573C9.074,6.489 9.137,6.376 9.172,6.232Z" style="fill-rule:nonzero;"/>
                                                </g>
                                                <g transform="matrix(1.22465e-16,-2,2.14962,1.31626e-16,-6.73132,21.952)">
                                                      <path d="M7.065,7.172C7.039,7.172 7.026,7.16 7.026,7.135L7.026,3.779C7.026,3.755 7.039,3.743 7.065,3.743L7.626,3.743C7.652,3.743 7.665,3.755 7.665,3.779L7.665,3.88C7.665,3.904 7.652,3.916 7.626,3.916L7.254,3.916C7.244,3.916 7.239,3.921 7.239,3.93L7.239,6.985C7.239,6.994 7.244,6.999 7.254,6.999L7.629,6.999C7.655,6.999 7.668,7.011 7.668,7.035L7.668,7.135C7.668,7.16 7.655,7.172 7.629,7.172L7.065,7.172Z" style="fill-rule:nonzero;"/>
                                                </g>
                                          </g>
                                    </svg>
                              </div>
                        </div>
                        <!-- bool -->
                        <multiselect v-else-if="filter.type === 'bool'" :value="filter.value" @input="filterValue($event, index)" :multiple="false" :options="['true', 'false']" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
                  </div>

                  <!-- always display dates filters -->
                  <div class="form" key="dates">
                        <label for="dateType">{{ $tc('date_label', 2) }}  <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_datefilter')"></feather></label>
                        <multiselect
                              id="dateType"
                              v-model="dateType"
                              label="name"
                              track-by="value"
                              @input="resetValues"
                              :multiple="false"
                              :options="dateTypeOptions"
                              :searchable="true"
                              :close-on-select="true"
                              :show-labels="false"
                              :placeholder="$t('select')">
                        </multiselect>
                        <div class="form mt-4" v-if="dateType && dateType.value == 1">
                              <div class="flex justify-between">
                                    <label for="dateRange">{{ $t('date_range') }}</label>
                              </div>
                              <div class="flex space-x-4 items-center mb-4">
                                    <v-date-picker :attributes="calendarAttributes" id="dateRange" v-model="dateFrom" :max-date="dateTo" mode="dateTime">
                                          <template v-slot="{ inputValue, inputEvents }">
                                                <input
                                                      class=""
                                                      :value="inputValue"
                                                      v-on="inputEvents"
                                                />
                                          </template>
                                    </v-date-picker>
                                    <feather type="chevron-right" stroke='#141935'></feather>
                                    <v-date-picker :attributes="calendarAttributes" v-model="dateTo" :min-date="dateFrom" mode="dateTime">
                                          <template v-slot="{ inputValue, inputEvents }">
                                                <input
                                                      class=""
                                                      :value="inputValue"
                                                      v-on="inputEvents"
                                                />
                                          </template>
                                    </v-date-picker>
                              </div>
                              <!-- <multiselect v-model="coverType" label="name" track-by="value" :multiple="false" :options="coverTypeOptions" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Select"></multiselect> -->
                        </div>
                        <div class="form mt-4" v-if="dateType && dateType.value == 0">
                              <div class="form flex items-center">Last <input :placeholder="$t('number')" class="flex-grow mx-2" type="number" step="1" min="1" v-model.number="backwardInterval"> {{ $tc('day', backwardInterval > 1 ? 2 : 1) }}</div>
                        </div>
                  </div>
            </transition-group>
            <div v-if="!isDerived" class="mt-4 tab-footer w-full flex justify-items-end space-x-2">
                  <dropdown-menu :withDropdownCloser="true" :overlay="false" direction="left" @opened="openFiltersSelect">
                        <div slot="trigger" class="bg-pureNavy py-1 px-4 rounded-2xl text-white uppercase font-bold text-sm cursor-pointer" v-tooltip="$t('add_another_filter')">{{ $t('add_filter') }}</div>
                        <multiselect ref="selectfilters" slot="body" :hideSelected="true" track-by="name" label="label" v-model="filters" :multiple="true" :options="filterOptions" :searchable="true" :close-on-select="false" :show-labels="false" :placeholder="$t('select')"></multiselect>
                  </dropdown-menu>
                  <slot></slot>
            </div>
      </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import ModalNewPath from '../ModalSelectFilterPath'
import ModalService from '../../modules/modals/services/modal.service'
import Vue from "vue";

export default {
      props: {
            filterOptions: {
                  type: Array,
                  required: true,
            },
            date_from: {
                  type: Object,
            },
            date_to: {
                  type: Object,
            },
            backward_interval: {
                  type: Number,
            },
            cover_type: {
                  type: Number,
            },
      },
      data(){
            return {
                  coverTypeOptions: [{ name: 'Covers even single occurrence', value: 0 },{ name: 'Covers the entire period', value: 1 }],
                  dateTypeOptions: [{ name: 'Last # of days', value: 0 },{ name: 'Date range', value: 1 }],
                  dateType: null,
                  refresh: false
            }
      },
      computed: {
            Vue() {
              return Vue
            },
            ...mapGetters([
                  'allColumns',
                  'newReport',
                  'calendarAttributes',
                  'activeReport',
                  'findReport',
                  'paths',
            ]),
            reportId(){
                  return this.newReport.id
            },
            columns (){
                  return this.allColumns.filter(column => {
                    return this.newReport.service_name == column.service
                  }).map(column => column.name)
            },
            isDerived() {
              if(this.activeReport.report !== null){
                const report = this.findReport(this.activeReport.report)
                return report.derived
              }
              return false
            },
            filters: {
                  get() {
                        return this.newReport.filters ? this.newReport.filters : []
                  },
                  set(value) {
                        this.$emit('update', {filters: value})
                  }
            },
            dateFrom: {
                  get() {
                        return this.date_from != null ? new Date(this.date_from + ' UTC') : null
                  },
                  set(value) {
                        this.$emit('update', {date_from: value})
                  }
            },
            dateTo: {
                  get() {
                        return this.date_to != null ? new Date(this.date_to + ' UTC') : null
                  },
                  set(value) {
                        this.$emit('update', {date_to: value})
                  }
            },
            backwardInterval: {
                  get() {
                        return this.backward_interval
                  },
                  set(value) {
                        this.$emit('update', {backward_interval: value > 0 ? value : null})
                  }
            },

            coverType: {
                  get() {
                        if(this.cover_type !== null) {
                              return this.coverTypeOptions[this.cover_type]
                        } else {
                              return null
                        }
                  },
                  set(value) {
                        if(value === null) {
                              this.$emit('update', {cover_type: value})
                        } else {
                              this.$emit('update', {cover_type: value.value})
                        }
                  }
            },
      },
      methods: {
            ...mapMutations({
                  setNewReportItem: 'setNewReportItem',
            }),
            fromToValue(value, index){
                  if(value != null && value.length) {
                        return value[index]
                  } else {
                        return null
                  }
            },
            filterValue(value, index, el) {
                  let filters = this.filters
                  if(el != null || el != undefined){
                        if(filters[index].value == null) filters[index].value = [null, null]
                        filters[index].value[el] = value
                  } else {
                        filters[index].value = value
                  }

                  this.$emit('update', {filters: filters})
              this.refresh = !this.refresh
              this.$forceUpdate()

            },
            enums(name) {
              if(this.activeReport.report !== null){
                const report = this.findReport(this.activeReport.report)
                return report.enums.columns[name].values || []
              }
              return []
            },
            toggleExactMatch(val, index){
                  let filters = this.filters
                  filters[index].like = val === null ? true : !val
                  this.$emit('update', {filters: filters})
                  this.$forceUpdate()
            },
            removeFilter(index){
                  let filters = this.filters
                  filters.splice(index,1)
                  this.$emit('update', {filters: filters})
            },
            openFiltersSelect(){
                  this.$refs.selectfilters.isOpen = true
                  this.$nextTick(()=>{
                        this.$refs.selectfilters.$refs.search.focus()
                  })
            },
            removePath(value, index){
                  let filters = this.filters
                  let updatedFilter = [...value]
                  updatedFilter.splice(index, 1)
                  const pathIndex = filters.findIndex(filter => filter.name == Vue.Constants.PATH_FILTER_NAME)
                  if(pathIndex != -1) {
                        this.filterValue(updatedFilter,pathIndex, null)
                  }
            },
            openModalNewPath(id, paths, filterName) {
                  ModalService.open(ModalNewPath, {id: id, paths: paths, filterName: filterName});
            },
            resetValues(value){
                  if (!value || value.value == null){
                        this.$emit('update', {date_from: null})
                        this.$emit('update', {date_to: null})
                        this.$emit('update', {backward_interval: null})
                  } else if (value.value == 0){
                        this.$emit('update', {date_from: null})
                        this.$emit('update', {date_to: null})
                  } else if (value.value == 1){
                        this.$emit('update', {backward_interval: null})
                  }
            },
            updateDateType(){
                  this.$nextTick(()=> {
                        // set dateType
                        if(this.backward_interval){
                              this.dateType = this.dateTypeOptions[0]
                        } else if (this.date_from || this.date_to ) {
                              this.dateType = this.dateTypeOptions[1]
                        } else {
                              this.resetValues()
                              this.dateType = null
                        }
                  })

            }
      },
      watch:{
            reportId: function (newId, oldId) {
                  if (oldId !== newId){
                        this.updateDateType()
                  }
            }
      },
      mounted(){
            this.updateDateType()
      }
}
</script>

<style lang="sass">
.tab-filters
      .v-dropdown-menu__container
            overflow: inherit
.btn-exact-match
      &.active
            @apply bg-pureNavy2
</style>
